module.exports = __webpack_public_path__ + "static/media/iSpani_Icon.85ebd78d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iSpani_Icon.jpeg
// module id = 1377
// module chunks = 0